import axios from 'axios';
import getImageById from '@/components/ImageSelector/getImageById';
import emitSelectedImage from '@/store/Modules/common/emitSelectedImage';

export default {
    namespaced: true,

    state() {
        return {
            showMediaSelector: false,
            showImageDeleteDialog: false,
            selectedImage: undefined,
            selectedImageSrc: undefined,
            activeTab: 'stockMedia',
            overlay: false,
            stockMedia: [],
            userMedia: [],
            uploadErrors: [],
            uploadType: 0,
            tags: [],
        };
    },

    mutations: {
        setLibraryTags(state, value) {
            state.libraryTags = value;
        },

        setUploadType(state, value) {
            state.uploadType = value;
        },

        setSelectedImage(state, value) {
            state.selectedImage = value;
        },

        setSelectedImageSrc(state, value) {
            state.selectedImageSrc = this._vm.$storageURL + value;
        },

        setActiveTab(state, value) {
            state.activeTab = value;
        },

        toggleOverlay(state, value) {
            state.overlay = value;
        },

        setUserMedia(state, value) {
            state.userMedia = value;
        },

        setStockMedia(state, value) {
            state.stockMedia = value;
        },

        toggleMediaSelector(state, value) {
            state.showMediaSelector = value;
        },

        toggleImageDeleteDialog(state, value) {
            state.showImageDeleteDialog = value;
        }
    },

    actions: {
        preloadStockMedia({commit}, payload) {
            return new Promise(resolve => {
                commit('setStockMedia', payload.sort((a, b) => (b.created_at > a.created_at) ? 1 : -1));
                resolve();
            });
        },

        /**
         * Stock Library.
         * Complete Stock Image Library.
         * Used for admin field image select. I.e. Website Preview Images.
         * Only called when library isn't passed in via prop from field..
         */
        getStockMedia({commit, dispatch}) {
            return new Promise(resolve => {
                axios.get('/api/media/index/')
                    .then(response => {
                        dispatch('filterMedia', response.data.media)
                            .then((response) => {
                                commit('setStockMedia', response);
                                resolve();
                            });
                    });
            });
        },

        preloadUserMedia({commit, dispatch}, payload) {
            return new Promise(resolve => {
                dispatch('filterMedia', payload)
                    .then((response) => {
                        commit('setUserMedia', response);
                        resolve();
                    });
            });
        },

        getUserMedia({commit, dispatch}) {
            return new Promise(resolve => {
                axios.get('/api/media/user-library')
                    .then(response => {
                        dispatch('filterMedia', response.data.userMedia)
                            .then((response) => {
                                commit('setUserMedia', response);
                                resolve();
                            });
                    });
            });
        },

        filterMedia({state}, mediaToFilter) {
            return new Promise((resolve, reject) => {
                let media = [];
                if(mediaToFilter) {
                    if (state.uploadType === 'image') {
                        mediaToFilter.forEach(file => {
                            if (file.aggregate_type !== 'pdf') {
                                media.push(file);
                            }
                        });
                    }

                    if(state.uploadType === 'pdf') {
                        mediaToFilter.forEach(file => {
                            if (file.aggregate_type === 'pdf') {
                                media.push(file);
                            }
                        });
                    }
                    resolve(media.sort((a, b) => (b.created_at > a.created_at) ? 1 : -1));
                }
                reject();
            });
        },

        // eslint-disable-next-line no-unused-vars
        deleteUserMedia({dispatch, commit}, mediaId) {
            return new Promise((resolve, reject) => {
                axios.post('/api/media/image/destroy/' + mediaId)
                    .then(() => {
                        dispatch('getUserMedia')
                            .then(() => {
                                resolve();
                            });
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },

        onThumbnailDeselect({commit, state}, payload) {
            return new Promise((resolve) => {
                commit('setSelectedImage', payload.item.id);
                commit('setSelectedImageSrc', 'placeholder/image-placeholder.jpg');
                emitSelectedImage(state, payload);
                resolve();
            });
        },

        onThumbnailSelect({commit, state}, payload) {
            return new Promise((resolve) => {

                // For database
                commit('setSelectedImage', payload.item.id);
                if (payload.item.extension === 'pdf') {
                    commit('setSelectedImageSrc', 'placeholder/pdf-placeholder.jpg');
                } else {
                    commit('setSelectedImageSrc', payload.item.directory + '/' + payload.item.filename + '.' + payload.item.extension);
                }
                emitSelectedImage(state, payload);
                resolve();
            });
        },

        setDefaultSelectedImage({state, commit}) {
            return new Promise(resolve => {
                if (state.stockMedia[0]) {
                    commit('setSelectedImage', '');
                    commit('setSelectedImageSrc', 'placeholder/image-placeholder.jpg');
                    resolve();
                }
            });
        },

        setSelectedImage({commit}, value) {
            return new Promise(resolve => {
                commit('setSelectedImage', value);
                resolve();
            });
        },

        getSelectedImage({state, commit}) {
            return new Promise(resolve => {
                if (!state.selectedImage || state.selectedImage === '' || state.selectedImage === 0) {
                    commit('setSelectedImageSrc', 'placeholder/image-placeholder.jpg');
                    resolve();
                } else {
                    getImageById(state.selectedImage)
                        .then(image => {
                            if (image.extension === 'pdf') {
                                commit('setSelectedImageSrc', 'placeholder/pdf-placeholder.jpg');
                            } else {
                                commit('setSelectedImageSrc', image.directory + '/' + image.filename + '.' + image.extension);
                            }

                            resolve();
                        })
                        .catch(() =>{
                            commit('setSelectedImageSrc', 'placeholder/image-placeholder.jpg');
                            resolve();
                        });
                }
            });
        }
    }
};
